import React, { useEffect } from "react";

// import animate on scroll
import Aos from "aos";
import "aos/dist/aos.css";

// import components
import Hero from "./id/Hero";
import About from "./id/About";
import Features from "./id/Features";
import Testimonials from "./id/Testimonials";
import Footer from "./id/Footer";
import Pricing from "./id/Pricing";
import FAQ from "./id/FAQ";

const AppId = ({ currentLanguage, onChangeLanguage }) => {
  // animate on scroll initialization
  useEffect(() => {
    Aos.init({
      duration: 1000,
      delay: 50,
      once: true,
      easing: "ease-out-cubic",
    });
  }, []);
  return (
    <div>
      <section id="hero">
        <Hero currentLanguage={currentLanguage} onChangeLanguage={onChangeLanguage} />
      </section>
      <section id="features">
        <Features />
      </section>
      <section id="pricing">
        <Pricing />
      </section>
      <section id="testimonials">
        <Testimonials />
      </section>
      <section id="about">
        <About />
      </section>
      <section id="faq">
        <FAQ />
      </section>
      <section id="footer">
        <Footer />
      </section>
    </div>
  );
};

export default AppId;
